<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GQNrUg/tc-custom/9781035825806.jpg?1718106146978" alt="This image is the cover for the book Telling Tales - Out of School"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Telling Tales - Out of School
      </h1>
      <p class="bookDescription body article font2">
        <p>Laugh, weep, be moved, challenged, and inspired, as you are taken on a journey of discovery. You might identify with the students – or relate to this teacher! Delve into her world, as she fulfils her childhood dream of becoming a wise and compassionate teacher. She considers teaching as the greatest privilege and responsibility. She taught her school subjects, but she also taught young people life skills: how to learn, laugh, live, love, forgive – and what really matters, in this short life we are gifted. She strongly believes that students need acceptance, and self-belief, in order to learn and to love learning – that they are worth her time, interest, and care. Her methods of engaging the interest of students were rarely traditional. But they worked! If students had difficulty, her calling as a teacher was to “find another way”. Every time. You will be touched not only by her variety of classroom stories, but by her honesty, humour, wit, and insights, but you’ll be hooked with her ‘teaching’ experiences as she travels with seven teenagers for three weeks in a foreign country. What could possibly go wrong? Enjoy.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Wendy Smith-Gordon
      </h2>
      
      <p class="authorDescription body article">Wendy taught for two years in tropical Queensland before living in France for two years. Subsequently, marriage and three children occupied normal life. The family then spent almost two years in Saudi Arabia, until their dramatic evacuation prior to the Gulf War. Back in Australia, the family fostered a severely disabled boy for ten years, later becoming his legal guardians. When the children became teenagers, she returned to teaching, her first passion. Wendy, now retired, follows other interests, including writing and loving her seven amazing and talented grandchildren, along with her special dog, Sunny, now an official Therapy Dog providing love and support to others.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1b428766